export class AddToMenuCheckBoxes {
  name: string;
  value: boolean;
}

export class AddToMenuProfiles {
  name: string;
  index: number;
  value: number;
}

export class AddToMenuPlanId {
  planId: number;
  weight: number;
}

export class AddToMenuShowModalObj {
  recipeId: number;
  stageId: number;
  calculationWeight: number;
  isModified: boolean;
  portion: number;
  typeMenu: number;
  singleNPart: number;
}




// WEBPACK FOOTER //
// ./src/app/shared/models/add-to-menu.ts